import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["htmlProps"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useAccordionItem } from "./chunk-JDQBKIKM.mjs";
import { AccordionItemProvider, useAccordionStyles } from "./chunk-JST25EWU.mjs";

// src/accordion-item.tsx
import { chakra, forwardRef } from "@chakra-ui/system";
import { cx } from "@chakra-ui/shared-utils";
import { useMemo } from "react";
import { jsx } from "react/jsx-runtime";
var AccordionItem = forwardRef(function AccordionItem2(props, ref) {
  var children = props.children,
    className = props.className;
  var _useAccordionItem = useAccordionItem(props),
    htmlProps = _useAccordionItem.htmlProps,
    context = _objectWithoutProperties(_useAccordionItem, _excluded);
  var styles = useAccordionStyles();
  var containerStyles = _objectSpread(_objectSpread({}, styles.container), {}, {
    overflowAnchor: "none"
  });
  var ctx = useMemo(function () {
    return context;
  }, [context]);
  return /* @__PURE__ */jsx(AccordionItemProvider, {
    value: ctx,
    children: /* @__PURE__ */jsx(chakra.div, _objectSpread(_objectSpread({
      ref: ref
    }, htmlProps), {}, {
      className: cx("chakra-accordion__item", className),
      __css: containerStyles,
      children: typeof children === "function" ? children({
        isExpanded: !!context.isOpen,
        isDisabled: !!context.isDisabled
      }) : children
    }))
  });
});
AccordionItem.displayName = "AccordionItem";
export { AccordionItem };